import React from "react";
import { DoubleContainerProps } from "./DoubleContainer.types";
import { DoubleContainerBox } from "./DoubleContainer.style";
import {
  ComponentMapping,
  Container,
} from "@adobe/aem-react-editable-components";
import { CoreContainerState } from "@adobe/aem-core-components-react-spa";

export default class DoubleContainer extends Container<
  DoubleContainerProps,
  CoreContainerState
> {
  constructor(props: DoubleContainerProps) {
    super(props);

    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
    };
  }

  render() {
    const { id } = this.props;
    return (
      <>
        <DoubleContainerBox id={id}>
          {this.childComponents &&
            this.childComponents.map((item, k) => {
              if (k < 2) {
                return <div key={k}>{item}</div>;
              }
              return null;
            })}
        </DoubleContainerBox>
        {this.childComponents.length < 2 && this.placeholderComponent}
      </>
    );
  }
}
